import MPayAbout from '../../components/MPayAbout';
import MPayDocumentation from '../../components/MPayDocumentation';
import MPayRoot from '../../components/MPayRoot';
import MPayLogin from '../../components/login/MPayLogin';
import MPayPasswordRenewal from '../../components/login/MPayPasswordRenewal';
import MPayUserProfileView from '../../components/MPayUserProfileView';
import MPayPasswordRecovery from '../../components/login/MPayPasswordRecovery';
import MPayCompleteUserRegistration from '../../components/login/MPayCompleteUserRegistration';
import MPayTransactions from '../../components/MPayTransactions';
import MPayTransactionDetailsView from '../../components/MPayTransactionDetailsView';
import MPayPurchaseDetailsView from '../../components/MPayPurchaseDetailsView';
import MPayExchangeXmlsPage from '../../components/MPayExchangeXmlsPage';
import MPayMerchantLimitedPage from '../../components/merchant/MPayMerchantLimitedPage';
import MPayMerchantEmployeesPage from '../../components/merchant/MPayMerchantEmployeesPage';
import MPayBusinessDays from '../../components/MPayBusinessDays';
import MPayMerchantCertificatesView from '../../components/merchant/MPayMerchantCertificatesView';
import MPayNotFound from '../../components/MPayNotFound';
import store from '../../store';
import Roles from '../../utils/user-roles';
import MPayEmployeeUpdateView from '../../components/merchant/MPayEmployeeUpdateView';
import MPayMerchantEmployeeCreateView from '../../components/merchant/MPayMerchantEmployeeCreateView';
import MPayMerchantWidgetsPage from '../../components/merchant/MPayMerchantWidgetsPage';
import MPayWidgetCreateView from '../../components/merchant/MPayWidgetCreateView';
import MPayWidgetUpdateView from '../../components/merchant/MPayWidgetUpdateView';
import MPayMerchantOrdersPage from '../../components/merchant/MPayMerchantOrdersPage';
import MPayOrderDetailsView from '../../components/merchant/MPayOrderDetailsView';
import MPayMerchantCertificateDetailsView from '../../components/merchant/MPayMerchantCertificateDetailsView';
import MPayMerchantShippingMethodsPage from '../../components/merchant/MPayMerchantShippingMethodsPage';
import MPayMerchantShippingMethodCreateView from '../../components/merchant/MPayMerchantShippingMethodCreateView';
import MPayMerchantShippingMethodUpdateView from '../../components/merchant/MPayMerchantShippingMethodUpdateView';
import MPayRecurrings from '../../components/MPayRecurrings';
import MPayConsumerCreditView from '../../components/MPayConsumerCreditView';

export default [
  {
    path: '/',
    name: 'home',
    component: MPayRoot,
  },
  {
    path: '/login',
    name: 'login',
    component: MPayLogin,
    beforeEnter: (routeTo, routeFrom, next) => {
      store.dispatch('tryAutoLogin');
      if (store.getters.isAuthenticated) {
        return next({ name: 'home' });
      }
      return next();
    },
  },
  {
    path: '/password-renewal',
    name: 'password-renewal',
    component: MPayPasswordRenewal,
  },
  {
    path: '/password-recovery',
    name: 'password-recovery',
    component: MPayPasswordRecovery,
  },
  {
    path: '/register',
    name: 'register',
    component: MPayCompleteUserRegistration,
  },
  {
    path: '/profile',
    name: 'profile',
    component: MPayUserProfileView,
  },
  {
    path: '/transactions',
    name: 'transactions',
    component: MPayTransactions,
    meta: {
      roles: [Roles.READ_MERCHANT_TRANSACTION],
      title: 'Transactions',
    },
  },
  {
    path: '/transactions/:transactionId',
    name: 'transaction',
    component: MPayTransactionDetailsView,
    meta: {
      roles: [Roles.READ_MERCHANT_TRANSACTION],
      title: 'Transaction Details',
      breadcrumbs: [
        { name: 'transactions' },
      ],
    },
  },
  {
    path: '/exchange-logs',
    name: 'exchange-logs',
    component: MPayExchangeXmlsPage,
    meta: {
      roles: [Roles.READ_MERCHANT_PURCHASE],
      title: 'Exchange Requests And Responses',
    },
  },
  {
    path: '/business-days',
    name: 'business-days',
    component: MPayBusinessDays,
    meta: {
      roles: [Roles.READ_MERCHANT_TRANSACTION],
      title: 'Business Days',
    },
  },
  {
    path: '/purchases/:purchaseId',
    name: 'purchase',
    component: MPayPurchaseDetailsView,
    meta: {
      roles: [Roles.READ_MERCHANT_PURCHASE],
      title: 'Purchase Details',
    },
  },
  {
    path: '/recurring',
    name: 'recurring',
    component: MPayRecurrings,
    meta: {
      roles: [Roles.READ_MERCHANT_PURCHASE],
      title: 'Recurring Payments',
    },
  },
  {
    path: '/merchant',
    name: 'merchant',
    component: MPayMerchantLimitedPage,
    meta: {
      title: 'Settings',
    },
  },
  {
    path: '/merchant-employees',
    name: 'merchant-employees',
    component: MPayMerchantEmployeesPage,
    meta: {
      title: 'Employees',
    },
  },
  {
    path: '/widgets',
    name: 'widgets',
    component: MPayMerchantWidgetsPage,
    meta: {
      roles: [Roles.READ_MERCHANT_WIDGET],
      title: 'Widgets',
    },
  },
  {
    path: '/shipping-methods',
    name: 'shipping-methods',
    component: MPayMerchantShippingMethodsPage,
    meta: {
      roles: [Roles.READ_MERCHANT_SHIPPING_METHOD],
      title: 'Shipping Methods',
    },
  },
  {
    path: '/shipping-methods/add',
    name: 'add-shipping-method',
    component: MPayMerchantShippingMethodCreateView,
    meta: {
      roles: [Roles.CREATE_MERCHANT_SHIPPING_METHOD],
      title: 'Shipping Method',
      breadcrumbs: [
        { name: 'shipping-methods' },
      ],
    },
  },
  {
    path: '/add-shipping-method',
    name: 'add-shipping-method',
    component: MPayMerchantShippingMethodCreateView,
    meta: {
      roles: [Roles.CREATE_MERCHANT_SHIPPING_METHOD],
      title: 'Shipping Method',
      breadcrumbs: [
        { name: 'shipping-methods' },
      ],
    },
  },
  {
    path: '/shipping-method/:id',
    name: 'shipping-method',
    component: MPayMerchantShippingMethodUpdateView,
    meta: {
      roles: [Roles.UPDATE_MERCHANT_SHIPPING_METHOD],
      title: 'Shipping Method',
      breadcrumbs: [
        { name: 'shipping-methods' },
      ],
    },
  },
  {
    path: '/users/:userId',
    name: 'user',
    component: MPayEmployeeUpdateView,
    meta: {
      roles: [Roles.READ_MERCHANT_EMPLOYEE],
      title: 'User Details',
      breadcrumbs: [
        { name: 'merchant-employees' },
      ],
    },
  },
  {
    path: '/merchant-employees/add',
    name: 'add-employee',
    component: MPayMerchantEmployeeCreateView,
  },
  {
    path: '/widgets/add',
    name: 'add-widget',
    component: MPayWidgetCreateView,
    meta: {
      roles: [Roles.CREATE_MERCHANT_WIDGET],
      title: 'Widget Details',
      breadcrumbs: [
        { name: 'widgets' },
      ],
    },
  },
  {
    path: '/widget/:widgetId',
    name: 'widget',
    component: MPayWidgetUpdateView,
    meta: {
      roles: [Roles.READ_MERCHANT_WIDGET],
      title: 'Widget',
      breadcrumbs: [
        { name: 'widgets' },
      ],
    },
  },
  {
    path: '/certs',
    name: 'certs',
    component: MPayMerchantCertificatesView,
    meta: {
      roles: [Roles.READ_MERCHANT_ORDER],
      title: 'Certificates',
    },
  },
  {
    path: '/cert/:certificateId',
    name: 'cert',
    component: MPayMerchantCertificateDetailsView,
    meta: {
      roles: [Roles.READ_MERCHANT_ORDER],
      title: 'Certificate details',
      breadcrumbs: [
        { name: 'certs' },
      ],
    },
  },
  {
    path: '/add-cert',
    name: 'add-cert',
    component: MPayMerchantCertificateDetailsView,
    meta: {
      roles: [Roles.READ_MERCHANT_ORDER],
      title: 'Certificate details',
      breadcrumbs: [
        { name: 'certs' },
      ],
    },
  },
  {
    path: '/orders',
    name: 'orders',
    component: MPayMerchantOrdersPage,
    meta: {
      roles: [Roles.READ_MERCHANT_ORDER],
      title: 'Orders',
    },
  },
  {
    path: '/order/:orderId',
    name: 'order',
    component: MPayOrderDetailsView,
    meta: {
      roles: [Roles.READ_MERCHANT_ORDER],
      title: 'Order details',
      breadcrumbs: [
        { name: 'orders' },
      ],
    },
  },
  {
    path: '/financing/consumer-credits/:consumerCreditId',
    name: 'consumer-credit',
    component: MPayConsumerCreditView,
    meta: {
      roles: [Roles.READ_MERCHANT_ORDER],
      title: 'Loan',
    },
  },
  {
    path: '/help',
    name: 'help',
    component: MPayAbout,
  },
  {
    path: '/documentation',
    name: 'documentation',
    component: MPayDocumentation,
  },
  {
    path: '/*',
    name: '404',
    component: MPayNotFound,
  },
];




// WEBPACK FOOTER //
// ./src/mc/router/routes-mc.js